import { render, staticRenderFns } from "./salesforce-chat.component.vue?vue&type=template&id=380fd92d&"
import script from "./salesforce-chat.component.vue?vue&type=script&lang=ts&"
export * from "./salesforce-chat.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports